var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.31 21.35",
    width: "20px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.edit0{display:none;fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.edit1{fill:none;stroke:#808285;stroke-width:1.3;stroke-miterlimit:10;}\n\t.edit2{fill:#808285;stroke:#808285;stroke-width:0.75;stroke-miterlimit:10;}>\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.33,
    y: -6.14,
    className: "edit0",
    width: 9.5,
    height: 10.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "edit1",
    d: "M1.39,20.31L1.27,20.2c-0.14-0.16,0-0.63,0.59-2.73c0.08-0.3,0.24-0.58,0.45-0.81L14.36,3.88l2.31-2.45 c0.67-0.71,1.65-0.86,2.2-0.35l0.81,0.76c0.55,0.52,0.45,1.51-0.22,2.21L5.21,19.18c-0.28,0.3-0.64,0.52-1.04,0.64 C2.32,20.36,1.68,20.57,1.39,20.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "edit1",
    d: "M3.9,21.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "edit1",
    d: "M-0.97,18.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "edit1",
    d: "M0.3,19.27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "edit1",
    d: "M-7.83-0.66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "edit1",
    d: "M-5.06,1.17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "edit2",
    d: "M22.1,20.76H8.66c-0.24,0-0.44-0.2-0.44-0.44v-0.34c0-0.24,0.2-0.44,0.44-0.44H22.1c0.24,0,0.44,0.2,0.44,0.44 v0.34C22.54,20.56,22.34,20.76,22.1,20.76z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f4ab2b630dfa3b473cb79215150d3201.svg";
export { ForwardRef as ReactComponent };